import React, { useState, useRef, useEffect } from 'react';
import styles from './styles.module.css'

const PhoneInput = ({
    value,
    addCode = false,
    onChange,
    placeholder = '0000000000',
    name = 'phone',
    className = 'form-control',
}) => {
    const [isEditing, setIsEditing] = useState(true);
    const [formattedValue, setFormattedValue] = useState('');
    const inputRef = useRef(null);

    // Function to sanitize the phone number
    const sanitizePhoneNumber = (input) => {
        const sanitized = input.replace(/\D/g, '');
        return sanitized.startsWith('1') ? sanitized.slice(1) : sanitized;
    };

    // Handle focus out: switch to display mode and format the number
    const handleFocusOut = () => {
        const sanitizedValue = sanitizePhoneNumber(value);
        const formatted = sanitizedValue ? `${addCode ? '+1' : ''} (${sanitizedValue.slice(0, 3)}) ${sanitizedValue.slice(3, 6)}-${sanitizedValue.slice(6)}` : '';
        setFormattedValue(formatted);
        setIsEditing(false);
    };

    // Handle focus in: sanitize and switch to edit mode
    const handleFocus = () => {
        const sanitizedValue = sanitizePhoneNumber(value);
        onChange({ target: { name, value: sanitizedValue } });
        setIsEditing(true);
        setTimeout(()=>{
             inputRef.current?.focus();
        }, 50);
       
    };

    useEffect(()=>{
        handleFocusOut()
        setIsEditing(false);
    },[])

    // Detect clicks outside of the component
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (inputRef.current && !inputRef.current.contains(event.target)) {
                if (isEditing) handleFocusOut();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isEditing, value]);

    return (
        <>
            {isEditing ? (
                <input
                    type="text"
                    value={value}
                    placeholder={placeholder}
                    onChange={onChange}
                    name={name}
                    className={className}
                    ref={inputRef}
                    onBlur={handleFocusOut}
                />
            ) : (
                <div onClick={handleFocus} className={`${className} ${value === '' ? styles['display-mode'] : ''}`}>
                    <input
                        type="hidden"
                        value={value}
                        placeholder={placeholder}
                        onChange={onChange}
                        name={name}
                        className={className}
                        ref={inputRef}
                        onBlur={handleFocusOut}
                    />
                    {formattedValue}
                </div>
            )}
        </>
    );
};

export default PhoneInput;
